module.exports = __webpack_public_path__ + "20221216:03503e97ddf972ec7716/img/Till-This-Day-Tile_no-spot.44aac0a.png";